import {
  Component,
  computed,
  inject,
  input,
  output,
  signal,
  untracked,
  viewChild,
} from '@angular/core';
import { SimpleDialogLayout, Button } from 'excellence-ui';
import {
  EnergyInterfaceCreateDialogFormModel,
  EnergyInterfacesStore,
  EnergyInterfaceState,
  toEnergyInterfacePayload,
} from '../../stores/energy-interfaces.store';
import { LocationsStore } from '../../../locations/store/locations.store';
import { TranslocoPipe } from '@jsverse/transloco';
import { EnergyInterfaceCreateForm } from '../../components/energy-interface-create-form/energy-interface-create-form';

@Component({
  selector: 'app-energy-interface-create-dialog',
  imports: [SimpleDialogLayout, Button, TranslocoPipe, EnergyInterfaceCreateForm],
  templateUrl: './energy-interface-create-dialog.html',
})
export class EnergyInterfaceCreateDialog {
  protected energyInterfacesStore = inject(EnergyInterfacesStore);
  protected locationsStore = inject(LocationsStore);

  locationId = input.required<string | null>();
  utilityType = input<Exclude<
    Exclude<EnergyInterfaceState['data'], null>['utilityType'],
    undefined
  > | null>(null);
  showUtilityTypeInput = input(true);
  energyInterfaceID = input<string | null>(null);

  clickCancel = output();
  createSuccess = output<string>();

  protected energyInterface = computed(
    () =>
      this.energyInterfacesStore
        .energyInterfaces()
        ?.find((ei) => ei.id === this.energyInterfaceID()) ?? null,
  );
  protected energyInterfaceData = computed(() => this.energyInterface()?.data ?? null);

  protected energyInterfaceForm = viewChild(EnergyInterfaceCreateForm);

  protected showFormValidityErrors = signal(false);

  protected isEditLoading = computed(() => this.energyInterface()?.isEditLoading ?? false);
  protected editError = computed(() => this.energyInterface()?.editError ?? null);

  protected async onSubmit(): Promise<void> {
    const energyIntefaceForm = untracked(() => this.energyInterfaceForm());
    if (!energyIntefaceForm) {
      return;
    }
    this.showFormValidityErrors.set(true);

    if (energyIntefaceForm.form().invalid()) {
      energyIntefaceForm.markAsTouched();
      return;
    }

    const id = await this.saveData(energyIntefaceForm.model());
    if (id && this.energyInterfacesStore.createError() === null) {
      energyIntefaceForm.form().reset();
      this.createSuccess.emit(id);
    }
  }

  private async saveData(model: EnergyInterfaceCreateDialogFormModel) {
    const id = this.energyInterfaceID();
    const payload = toEnergyInterfacePayload(model);
    if (id) {
      await this.energyInterfacesStore.update(id, payload);
      return id;
    } else {
      return await this.energyInterfacesStore.create(payload);
    }
  }
}
